export default __webpack_public_path__ + "static/media/imageTum5.56059ea3.jpg";